// extracted by mini-css-extract-plugin
module.exports = {"retry_box":"FJPreviewRetry_retry_box__2fISP","text":"FJPreviewRetry_text__2zx1f","btn":"FJPreviewRetry_btn__2hV6p"};